import { api } from "../api.slice";
import { GetFinanceResponseType } from "@/types/finance";
import FinanceCalenderEvent from "@/types/calender-event";
import { apiEndpoints } from "@/utils/api-endpoints";
import PageResponse from "@/types/page-response";

const financeApi = api.injectEndpoints({
    overrideExisting: true,
    endpoints: (builder) => ({
        getAdminCalendar: builder.query<any, void>({
            query: () => apiEndpoints.Finance.GetAdminCalendarEvents.url,
            providesTags: [{ type: "Finance" }],
        }),
        getFinance: builder.query<GetFinanceResponseType, number>({
            query: (pageNumber) => `${apiEndpoints.Finance.GetFinance.url}?page=${pageNumber}`,
            providesTags: (result, error, arg) => [{ type: "Finance", arg }],
        }),
        getUserFinance: builder.query<GetFinanceResponseType, { page: number; userId: string }>({
            query: ({ page = 1, userId }) => {
                const endpoint = apiEndpoints.Finance.GetUserFinance(userId);

                return {
                    url: endpoint.url,
                    method: endpoint.method,
                    params: { page },
                };
            },
            providesTags: ["Finance"],
        }),
        getBalance: builder.query<number, void>({
            query: () => apiEndpoints.Finance.GetBalance.url,
            providesTags: ["Finance"],
        }),
        getUserBalance: builder.query<number, string>({
            query: (userId) => apiEndpoints.Finance.GetUserBalance(userId).url,
            providesTags: ["Finance"],
        }),
        getFinancialEvents: builder.query<FinanceCalenderEvent[], void>({
            query: () => ({
                url: apiEndpoints.Finance.GetCalendarEvents.url,
            }),
            providesTags: ["FinancialEvents"],
        }),

        getAdminFinancialEvents: builder.query<FinanceCalenderEvent[], string>({
            query: (userId) => ({
                url: apiEndpoints.Finance.GetCalendarEventsAdmin.url(userId),
            }),
            providesTags: ["FinancialEvents"],
        }),

    }),
});

export const {
    useGetAdminCalendarQuery,
    useGetFinanceQuery,
    useGetUserFinanceQuery,
    useGetBalanceQuery,
    useGetUserBalanceQuery,
    useGetFinancialEventsQuery,
    useGetAdminFinancialEventsQuery,
} = financeApi;
